import React from 'react';
import ReactDOM from 'react-dom/client';
// import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { SW_UPDATE_EVENT } from './components/SwUpdateNotification';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Service Worker の登録（本番ビルドのみ有効）。
// 更新を検知しても勝手にはリロードしない。イベントを投げて、
// SwUpdateNotification が出す通知からユーザーに了承を取る。
serviceWorkerRegistration.register({
  onUpdate: registration => {
    window.dispatchEvent(new CustomEvent(SW_UPDATE_EVENT, { detail: registration }));
  },
  onSuccess: () => {
    console.log('オフラインでの起動準備が整いました。');
  }
});

reportWebVitals();
